import { cn } from "ui";

import { normalizeLabelColor } from "src/lib/labelColors";

export function LabelPickerTriggerDot(props: {
  color: string;
  overlaps: boolean;
}) {
  return (
    <span
      className={cn(
        "size-3 rounded-full border border-black/10 ring-1 ring-background",
        props.overlaps && "-ml-1",
      )}
      style={{ backgroundColor: normalizeLabelColor(props.color) }}
    />
  );
}
